// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f657204d","171":"44e1a121","444":"30c118d0","507":"55c568e2","968":"413abf3f"}[chunkId] + ".chunk.js";
};